import {
  REPORT_TURNAROUND_SHORT,
  TURNAROUND_DISCLAIMER,
} from '@repo/contracts/services-pricing';

import { Container, SectionHeading } from '../ui';

const STEPS = [
  { body: 'Send your URL and any context. It’s free.', title: 'Request' },
  {
    body: 'We agree scope, then share early findings and a quote.',
    title: 'Scoping & teaser',
  },
  {
    body: `Every finding checked by a specialist. Usually delivered ${REPORT_TURNAROUND_SHORT} after payment.`,
    title: 'Verified report',
  },
  {
    body: 'Show your audit with a badge anyone can check.',
    title: 'Verifiable badge',
  },
];

export function HowItWorks() {
  return (
    <section
      aria-labelledby="how-title"
      className="bg-surface py-24 md:py-32"
      id="how-it-works"
    >
      <Container>
        <SectionHeading
          eyebrow="How it works"
          id="how-title"
          title="See the findings before you pay"
        />
        <ol className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {STEPS.map((step, i) => (
            <li key={step.title}>
              <span
                aria-hidden
                className="font-report text-report-stat font-medium text-text-muted"
              >
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 text-subtitle font-semibold text-text-primary">
                <span className="sr-only">Step {i + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 text-ui-lg text-text-secondary">{step.body}</p>
            </li>
          ))}
        </ol>
        <p className="mt-10 max-w-3xl text-caption text-text-secondary">
          {TURNAROUND_DISCLAIMER}
        </p>
      </Container>
    </section>
  );
}
